import React from "react";
import { Button, Row, Breadcrumb, Col, Typography, Space } from "antd";
import { HomeOutlined, MailOutlined, EyeOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

function Header({ projectId }) {
  const { Title } = Typography;
  const viewProject = () => {
    //action to be added
  };

  return (
    <Row className="titlt-part" align="middle">
      <Col xs={24} md={8}>
        <Title level={4}> {projectId ? "Edit Project" : "Add Project"}</Title>
      </Col>
      <Col xs={24} md={16} className="text-right">
        <Space>
          <Breadcrumb>
            <Breadcrumb.Item href="/DashBoard">
              <HomeOutlined />
              <span>Home</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/project/viewprojects">
              <span>Projects</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {projectId ? "Edit Project" : "Add Project"}
            </Breadcrumb.Item>
          </Breadcrumb>
          <Link to="/project/viewprojects">
            <Button type="primary">
              <EyeOutlined /> View Project
            </Button>
          </Link>
        </Space>
      </Col>
    </Row>
    // <Row>
    //   <h2 className="title gx-mb-4">
    //     Add Project
    //     <Breadcrumb>
    //       <Breadcrumb.Item href="/DashBoard">
    //         <HomeOutlined />
    //         <span>Home</span>
    //       </Breadcrumb.Item>
    //       <Breadcrumb.Item href="/project/viewprojects">
    //         <MailOutlined />
    //         <span>Projects</span>
    //       </Breadcrumb.Item>
    //       <Breadcrumb.Item>Add Project</Breadcrumb.Item>
    //     </Breadcrumb>
    //   </h2>
    //   <Button
    //     justify="end"
    //     type="primary"
    //     icon={<EyeOutlined />}
    //     style={{ marginLeft: "auto" }}
    //     onClick={viewProject}
    //   >
    //     &nbsp;
    //     <Link to="/project/viewprojects" style={{ color: "white" }}>
    //       View Project
    //     </Link>
    //   </Button>
    // </Row>
  );
}

export default Header;
